import { render, staticRenderFns } from "./AccountSelection.vue?vue&type=template&id=c0b0234e&scoped=true&"
import script from "./AccountSelection.vue?vue&type=script&lang=js&"
export * from "./AccountSelection.vue?vue&type=script&lang=js&"
import style0 from "./AccountSelection.vue?vue&type=style&index=0&id=c0b0234e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b0234e",
  null
  
)

export default component.exports